import styled from 'styled-components';

import { ReactComponent as Cyberfund } from './cyberfund.svg';
import { ReactComponent as ArringtonCapital } from './arrington_capital.svg';
import { ReactComponent as ParaFi } from './parafi.svg';
import { ReactComponent as Principle } from './principle.svg';
import { ReactComponent as Lemniscap } from './lemniscap.svg';
import { ReactComponent as PolymorphicCapital } from './polymorphic_capital.svg';
import { ReactComponent as Bloccelerate } from './bloccelerate.svg';
import { ReactComponent as RobotVentures } from './robotventures.svg';

const partners = [
  Cyberfund,
  ArringtonCapital,
  ParaFi,
  Principle,
  Lemniscap,
  PolymorphicCapital,
  Bloccelerate,
  RobotVentures,
];

const Mask = styled.div`
  width: 100%;
  --mask: linear-gradient(
      to left,
      rgba(16, 17, 21, 0) 0%,
      rgba(16, 17, 21, 1) 10%,
      rgba(16, 17, 21, 1) 90%,
      rgba(16, 17, 21, 0) 100%
    )
    100% 50% / 100% 100% repeat-x;

  -webkit-mask: var(--mask);
  mask: var(--mask);
`;

const Slider = styled.div`
  --slider-item-width: 190px;
  --slider-items-count: ${partners.length};

  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(calc(-1 * var(--slider-item-width) * var(--slider-items-count)));
    }
  }

  margin: auto;
  overflow: hidden;
  position: relative;
  z-index: 1;

  .slide-track {
    animation: scroll calc(var(--slider-items-count) * 4s) linear infinite;
    display: flex;
    width: calc(var(--slider-item-width) * 2 * var(--slider-items-count));
  }

  .slide {
    height: 48px;
    width: var(--slider-item-width);

    & svg {
      height: 48px;
      width: var(--slider-item-width);
    }
  }

  @media (min-width: 1240px) {
    max-width: 1200px;
  }
`;

export const PartnersSlider = () => (
  <Mask>
    <Slider>
      <div className="slide-track">
        {partners.map((TrustedIcon, index) => (
          <div key={`slide_${index}`} className="slide">
            <TrustedIcon />
          </div>
        ))}
        {partners.map((TrustedIcon, index) => (
          <div key={`slide0_${index}`} className="slide">
            <TrustedIcon />
          </div>
        ))}
      </div>
    </Slider>
  </Mask>
);
